// eslint-disable-next-line unicorn/prevent-abbreviations
import template from './dev7.html';
import controller from './dev7.controller';
import './dev7.scss';

import { makeRoute } from '~/utils/route';

export default makeRoute({
	template,
	controller,
	title: 'dev7',
	path: '/dev7',
	onlyDev: true,
});
